import { memo } from 'react';
import _ from 'lodash';

// @mui
import { Avatar, Grid, Stack, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

// components
import { SvgAllApplicationFill } from '../../components/SvgIcons';
import { NoData } from '../../components/error';

// store
import { IconPopover } from '../@popover/IconPopover';



/* ======================================================================================= */


const ApplicationPopover = ({ applications = [], color = `#FFFFFF`, position = { x: '-128px' } }) => {
    const theme = useTheme();
    return (
      <IconPopover
        position={position}
        primary={
          <Stack direction={'row'} alignItems={`center`}>
            <SvgAllApplicationFill />
          </Stack>
        }
        content={
          <Stack
            minWidth={280}
            p={2}
            spacing={0.75}
          >
            <Grid container>
              {
                applications && applications?.length > 0 ? _.map(applications, (option, index) => {
                  return (
                    <Grid 
                      key={index} 
                      item 
                      xs={4} 
                      sm={4} 
                      md={4} 
                      lg={4}
                      sx={{
                        cursor: 'pointer',
                        borderRadius: '4px',
                        paddingBlock: theme.spacing(1),
                        paddingInline: theme.spacing(1.5),
                        transition: 'all 300ms ease',
                        '&:hover': {
                          boxShadow: '0px 2px 8px 0px rgba(157, 172, 208, 0.25)',
                        }
                      }}
                      onClick={() => window.open(option?.redirectUrl)}
                    >
                      <Avatar 
                        variant="rounded"
                        src={option?.logoSrc}
                        sx={{ mx: 'auto', mb: 0.5 }}
                      /> 
                      <Typography variant='body1' textAlign={'center'} noWrap>{option?.title}</Typography>
                    </Grid>
                  )
                }) : (<Grid item xs={12}><NoData /></Grid>)
              }
            </Grid>
          </Stack>
          
            // <Stack
            //   p={1}
            //   component={'ul'}
            //   spacing={0.75}
            //   sx={{
            //       '& .MuiMenuItem-root': {
            //           color: 'common.black',
            //           fontWeight: 700,
            //           fontSize: 16,
            //           px: 1.5,
            //           py: 1,
            //           transition: 'all 300ms ease',
            //           ...theme.typography.hoverSecondaryUnderline2px,
            //       },
            //       '& .MuiMenuItem-root.Mui-selected, & .MuiMenuItem-root:hover': {
            //           color: 'action.selected',
            //       },
            //       '& .MuiMenuItem-root.Mui-selected': {
            //           backgroundColor: 'transparent',
            //       },
            //       '& .MuiMenuItem-root:hover': {
            //           backgroundColor: `${theme.palette.action.hover} !important`,
            //       }
            //   }}
            // >
            //     {
            //       _.map(applications, option => {
            //         return (
            //           <Stack direction={'row'}>
            //             <Avatar 
            //               variant="rounded"
            //               src={option?.logoSrc}
            //             /> 
            //             {option?.title}
            //           </Stack>
            //         )
            //       })
            //     }
            // </Stack>
        }
      />
    );
};

export default memo(ApplicationPopover);
